import axios from "axios";

const store = {
    state: {
    },

    getters: {
    },

    mutations: {
    },

    actions: {
        payrollStoreAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payroll/store`, payload)
                    .then((res) => {
                        resolve(res.data.payroll);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        payrollsFindAction() {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payroll/find`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        payrollUpdateAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payroll/update`, payload)
                    .then((res) => {
                        resolve(res.data.payroll);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        deletePayrollAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payroll/delete`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        loadPayrollsTotalAction() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/payroll/totals`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        payrollsFindByIdAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payroll/find-by-id`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        assignEmployeeToPayrollAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payroll/assing-payroll`, payload)
                    .then((res) => {
                        resolve(res.data.employee);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        payrollsFindByArgAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payroll/find-by-arg`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });

        }
    },
};

export default store;
